const environmentVariables = {
  clientOptions: [
    {
      label: '100',
      value: `100`,
    },
  ],
  client: '100',
  systemIP: 'https://ahm-api-mgmt-prod.azure-api.net/sapb2bappprod',
  system: 'PRD',
  environment: 'PRD',
};

export { environmentVariables };
